import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const SvgPerformanceIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 28 28">
      <path d="M5.5 13.1C5.5 12.6029 5.94772 12.2 6.5 12.2C7.05228 12.2 7.5 12.6029 7.5 13.1V22.1C7.5 22.5971 7.05228 23 6.5 23C5.94772 23 5.5 22.5971 5.5 22.1V13.1Z" fill="#2E434D"/>
      <path d="M10.5 9.5C10.5 9.00294 10.9477 8.6 11.5 8.6C12.0523 8.6 12.5 9.00294 12.5 9.5V22.1C12.5 22.5971 12.0523 23 11.5 23C10.9477 23 10.5 22.5971 10.5 22.1V9.5Z" fill="#2E434D"/>
      <path d="M20.5 5.9C20.5 5.40294 20.9477 5 21.5 5C22.0523 5 22.5 5.40294 22.5 5.9V22.1C22.5 22.5971 22.0523 23 21.5 23C20.9477 23 20.5 22.5971 20.5 22.1V5.9Z" fill="#2E434D"/>
      <path d="M15.5 13.1C15.5 12.6029 15.9477 12.2 16.5 12.2C17.0523 12.2 17.5 12.6029 17.5 13.1V22.1C17.5 22.5971 17.0523 23 16.5 23C15.9477 23 15.5 22.5971 15.5 22.1V13.1Z" fill="#2E434D"/>
    </SvgIcon>
  );
};

export default SvgPerformanceIcon;
